import { ErrorMessage } from "formik";
import { FC } from "react";

import classes from "./validationErrorMessage.scss";

interface IValidationErrorMessageProps {
  name: string;
}

const ValidationErrorMessage: FC<IValidationErrorMessageProps> = ({ name }) => {
  return (
    <div
      className={`${classes.error} validation-error-message`}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      id={`${name}-error`}
    >
      <ErrorMessage name={name} />
    </div>
  );
};

export default ValidationErrorMessage;
